import { Component, OnInit } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { ClientUser } from '@app/shared/models/client-user';
import { UntypedFormControl, Validators } from '@angular/forms';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';


@Component({
    selector: 'user-core',
    styleUrls: ['./user-core.component.scss'],
    templateUrl: './user-core.component.html'
})
export class UserCoreComponent extends TwoWayBoundComponent<ClientUser>
                               implements OnInit {

    public email: UntypedFormControl;

    get user() {
        return this.bananaBox;
    }

    constructor() {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();

        this.email = new UntypedFormControl(
            {
                value: this.bananaBox.email,
                disabled: this.disabled
            },
            {
                updateOn: 'blur',
                validators: [Validators.required, Validators.email]
            });
    }

    public getEmailError(): string {
        return this.email.hasError('email') ? marker('user_management.error.email.invalid') :
            this.email.hasError('exists') ? marker('user_management.error.email.exists') :
                this.email.hasError('required') ? marker('user_management.error.email.required') :
                    '';
    }

    public valid(andTouch?: boolean): boolean {
        if (this.email) {
            if (andTouch) {
                this.email.markAsTouched();
            }

            return !this.email || !this.email.invalid;
        } else {
            return true;
        }
    }

}
